import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
  standardColours,
  brandColours,
  fontSize,
} from '../styles';
import { Heading, Button } from './ui';

const StyledImageCta = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  background-color: ${brandColours.primary};

  ${minBreakpointQuery.smedium`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
  `}
`;

const StyledContent = styled.div`
  padding: 40px 30px;
  color: ${standardColours.white};

  ${minBreakpointQuery.small`
    padding-top: 50px;
    padding-bottom: 50px;
  `}

  ${minBreakpointQuery.smedium`
    padding-right: 50px;
    padding-left: 50px;
    max-width: 700px;
    margin-left: auto;
  `}

  ${minBreakpointQuery.large`
    padding: 60px;
  `}

  ${minBreakpointQuery.xlarge`
    padding: 70px;
  `}

  ${minBreakpointQuery.xxlarge`
    padding: 80px;
  `}

  ${minBreakpointQuery.xxxlarge`
    padding: 90px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    padding: 100px;
  `}
`;

const StyledText = styled.p`
  margin-top: 20px;
  line-height: 1.5;

  ${minBreakpointQuery.large`
    ${fontSize(18)};
  `}
`;

const StyledButton = styled(Button)`
  margin-top: 25px;
`;

const StyledImage = styled(GatsbyImage)`
  ${maxBreakpointQuery.smedium`
    min-height: 200px;
    max-height: 35vw;
  `}

  ${minBreakpointQuery.smedium`
    height: 100%;
  `}
`;

const ImageCta = ({ heading, text, link, image }) => (
  <StyledImageCta>
    <StyledInner>
      <StyledContent>
        <Heading>{heading}</Heading>
        {text && <StyledText>{text}</StyledText>}
        <StyledButton to={link.page} alt={true}>
          {link.text}
        </StyledButton>
      </StyledContent>
      <StyledImage image={image.gatsbyImageData} alt={image.alt} />
    </StyledInner>
  </StyledImageCta>
);

export default ImageCta;
